
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPlayer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"response"},"name":{"kind":"Name","value":"getPlayer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"room_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"student_number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"student_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"student_email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"chirp_username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"video_status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"infobox_status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"about_you"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"goals"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"channel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"personal_goals"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"what_you_should_do"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"want"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dont_want"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"att_authority"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"att_experience"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"att_transparency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"att_ambition"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"att_loyalty"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"importance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"npc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"difficulty"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"relations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relation_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"score"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":535}};
    doc.loc.source = {"body":"query getPlayer($id: ID!) {\n\tresponse: getPlayer(id: $id) {\n\t\tid\n\t\troom_id\n\t\tstudent_number\n\t\tavatar\n\t\tname\n\t\tstudent_name\n\t\tstudent_email\n\t\tchirp_username\n\t\tdata\n\t\tvideo_status\n\t\tinfobox_status\n\t\trole {\n\t\t\tid\n\t\t\tname\n\t\t\tabout_you\n\t\t\trole_description\n\t\t\tgoals\n\t\t\tchannel\n\t\t\tpersonal_goals\n\t\t\twhat_you_should_do\n\t\t\twant\n\t\t\tdont_want\n\t\t\tatt_authority\n\t\t\tatt_experience\n\t\t\tatt_transparency\n\t\t\tatt_ambition\n\t\t\tatt_loyalty\n\t\t\timportance\n\t\t\ttag\n\t\t\tnpc\n\t\t\tdifficulty\n\t\t\tcategory\n\t\t\trelations {\n\t\t\t\trelation_id\n\t\t\t\tname\n\t\t\t\tscore\n\t\t\t}\n\t\t}\n\t}\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getPlayer"] = oneQuery(doc, "getPlayer");
        
